export default "__VITE_ASSET__B9VN5WBk__"